import React from 'react';
import { Box, Typography, Button, Stack, Paper, Divider } from '@mui/material';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import WarningIcon from '@mui/icons-material/Warning';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CelebrationIcon from '@mui/icons-material/Celebration';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import BoltIcon from '@mui/icons-material/Bolt'
import DiscountIcon from '@mui/icons-material/Discount'

const OrderSuccessMessage = ({
  isOwner,
  errorOccurred,
  handleClickPrintRemove,
  user,
  closeDialogForm,
}) => {
  return (
    <>
      <Box mt={6} mb={5} textAlign="center">
        {isOwner ? (
          <>
            <AssignmentTurnedInIcon color="primary" sx={{ fontSize: 90 }} />
            <Typography
              variant="subtitle1"
              color="textSecondary"
              align="center"
              sx={{ letterSpacing: 1, mt: 2 }}
            >
              Ordine effettuato con successo!
            </Typography>

            {errorOccurred && (
              <Stack spacing={2} alignItems="center" justifyContent="center" mt={3}>
                <WarningIcon color="error" fontSize="large" />
                <Typography
                  variant="subtitle1"
                  color="secondary"
                  align="center"
                  sx={{ letterSpacing: 1 }}
                >
                  Stampa automatica non disponibile
                </Typography>
                <Button variant="outlined" color="primary" onClick={handleClickPrintRemove}>
                  Stampa con il browser
                </Button>
              </Stack>
            )}
          </>
        ) : (
          <>
            {user.id === 'anonymus' ? (
              <Box sx={{ textAlign: 'center', p: 1, maxWidth: 520, mx: 'auto' }}>

                {/* CONFERMA ORDINE */}
                <ForwardToInboxIcon color="primary" sx={{ fontSize: 80, mb: 1, opacity: 0.9 }} />

                <Box display="flex" justifyContent="center" alignItems="center" gap={1} mb={1}>
                  <CelebrationIcon color="primary" sx={{ fontSize: 38 }} />
                  <Typography color="primary" variant="h4" fontWeight="900">
                    Ordine ricevuto!
                  </Typography>
                  <CelebrationIcon color="primary" sx={{ fontSize: 38, transform: 'scaleX(-1)' }} />
                </Box>

                <Box
                  sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 1,
                    color: 'text.secondary',
                    bgcolor: 'black',
                    py: 0.8,
                    px: 2,
                    borderRadius: 3,
                    mb: 3
                  }}
                >
                  <InfoOutlinedIcon fontSize="small" />
                  <Typography variant="body2">
                    Controlla l'email (anche nello <b>Spam</b>)
                  </Typography>
                </Box>

                {/* FIDELITY CARD PREMIUM BOX */}
                <Paper
                  elevation={8}
                  sx={{
                    bgcolor: '#0b0b0b',
                    color: 'white',
                    p: 3.5,
                    borderRadius: 4,
                    border: '1px solid #222',
                    backdropFilter: 'blur(6px)'
                  }}
                >
                  {/* ICONA */}
                  <Box
                    sx={{
                      display: 'inline-flex',
                      p: 1.3,
                      borderRadius: '50%',
                      bgcolor: 'rgba(100, 246, 112, 0.15)',
                      mb: 1.5
                    }}
                  >
                    <CardMembershipIcon color="primary" sx={{ fontSize: 44 }} />
                  </Box>

                  {/* HEADLINE */}
                  <Typography variant="h5" fontWeight="900" sx={{ mb: 1 }}>
                    Non perdere i <Box component="span" sx={{ color: 'primary.main' }}>punti del tuo ordine</Box>
                  </Typography>

                  <Typography variant="body1" sx={{ opacity: 0.85, mb: 2 }}>
                    Attiva il tuo profilo in 30 secondi per salvare e tracciare questo ordine.
                  </Typography>

                  <Divider sx={{ bgcolor: '#222', my: 2 }} />

                  {/* BENEFITS */}
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.3, textAlign: 'left', mb: 2 }}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <LocalShippingIcon color="primary" />
                      <Typography variant="body2">Traccia tutti i tuoi ordini</Typography>
                    </Box>

                    <Box display="flex" alignItems="center" gap={1}>
                      <BoltIcon color="primary" />
                      <Typography variant="body2">Ordina in 2 click</Typography>
                    </Box>

                    <Box display="flex" alignItems="center" gap={1}>
                      <DiscountIcon color="primary" />
                      <Typography variant="body2">Accumula punti</Typography>
                    </Box>
                  </Box>

                  {/* CTA */}
                  <Button
                    variant="contained"
                    fullWidth
                    size="large"
                    onClick={() => window.location.href = '/user/signup'}
                    sx={{
                      bgcolor: 'white',
                      color: 'black',
                      fontWeight: 900,
                      py: 1.6,
                      fontSize: '1rem',
                      textTransform: 'none',
                      borderRadius: 3,
                      transition: 'all 0.25s ease',
                      '&:hover': {
                        bgcolor: '#43a047',
                        color: 'white',
                        boxShadow: '0px 10px 25px rgba(67,160,71,0.5)'
                      }
                    }}
                  >
                    Salva il mio ordine!
                  </Button>
                </Paper>

              </Box>
            ) : (
              <>
                <AssignmentTurnedInIcon color="primary" sx={{ fontSize: 90 }} />
                <Typography
                  variant="subtitle1"
                  color="textSecondary"
                  align="center"
                  sx={{ letterSpacing: 1, mt: 2 }}
                >
                  Il tuo ordine è stato ricevuto!
                  <br />
                  Puoi consultarlo nella tua area personale.
                </Typography>

                <Button
                  variant="contained"
                  color="primary"
                  sx={{ mt: 3 }}
                  onClick={() => window.location.href = '/user/historyOrder'}
                >
                  Vai ai tuoi ordini
                </Button>
              </>
            )}
          </>
        )}
      </Box>

      {(user.id === 'anonymus' || isOwner) && (
        <Box display="flex" justifyContent="center" mt={3}>
          <Button
            variant="contained"
            color="primary"
            onClick={closeDialogForm}
            sx={{ minWidth: 300 }}
          >
            Chiudi
          </Button>
        </Box>
      )}
    </>
  );
};

export default OrderSuccessMessage;
